import { createFileRoute } from '@tanstack/react-router';
import { ErrorPage } from '@/components/ErrorPage';
import { useAuth } from '@/context/useAuth';
import { CreateCommiteePage } from '@/features/management/components/CreateCommiteePage';

export const Route = createFileRoute('/gestion/create')({
  component: RouteComponent,
});

function RouteComponent() {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return (
      <ErrorPage
        title="Accès non autorisé"
        message="Seuls les administrateurs peuvent créer une entreprise."
      />
    );
  }

  return <CreateCommiteePage />;
}
